import { Container, Button } from "react-bootstrap";
import "../../styles/SplitHero.css";

const SplitHero = ({
  title,
  description,
  buttonText,
  onButtonClick,
  imageSrc,
  imageAlt = "Hero image",
  imagePosition = "left",
  bgClass = "bg-primary-gradient",
  cardOffsetDesktop = "6%",
  cardOffsetMobile = "0",
   variant = "overlay", //  new prop
}) => {
  const isImageRight = imagePosition === "right";

  const cardStyle = {
    marginLeft: isImageRight ? cardOffsetDesktop : "auto",
    marginRight: isImageRight ? "auto" : cardOffsetDesktop,
  };

  const isSplit = variant === "split";

return (
  <section
    className={`split-hero ${
      isSplit ? "split-clean" : bgClass
    }`}
  >

{isSplit ? (
  <Container className="split-clean-container">

    <div className="split-clean-left">
      <h1 className="wise-secondary-gradient split-hero-title">
        {title}
      </h1>

      <p className="split-hero-desc">
        {description}
      </p>

      {buttonText && (
        <Button
  className="mentorship-btn split-mobile-btn"
  onClick={onButtonClick}
>
  {buttonText}
</Button>
      )}
    </div>

    <div className="split-clean-right">
      <img src={imageSrc} alt={imageAlt} />
    </div>

  </Container>
) : (

  <>
    <img
      src={imageSrc}
      alt={imageAlt}
      className={`split-hero-img ${
        isImageRight ? "img-right" : "img-left"
      }`}
    />

    <div className="split-hero-overlay" />

    <Container className="split-hero-container">
      <div className="bg-title split-hero-card" style={cardStyle}>
        <h1 className="wise-secondary-gradient split-hero-title">
          {title}
        </h1>

        <p className="text-secondary split-hero-desc">
          {description}
        </p>

        {buttonText && (
          <Button className="mentorship-btn" onClick={onButtonClick}>
  {buttonText}
</Button>
        )}
      </div>
    </Container>
  </>
)}

    </section>
  );
};

export default SplitHero;
